import { render, staticRenderFns } from "./vCard.vue?vue&type=template&id=0c57423c&scoped=true&"
import script from "./vCard.vue?vue&type=script&lang=js&"
export * from "./vCard.vue?vue&type=script&lang=js&"
import style0 from "./vCard.vue?vue&type=style&index=0&id=0c57423c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c57423c",
  null
  
)

/* custom blocks */
import block0 from "./vCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports